import DraggableItem from "./DraggableItem";

const DraggableContainer = ({
  items,
  onClick,
  onExchange,
  onCancle,
  contentDisable,
  editable = true,
  isProduct,
}) => {
  return (
    <div className="images-container">
      {items.map((image, index, item) => (
        <DraggableItem
          key={index}
          image={image}
          index={index}
          onClick={onClick}
          onExchange={onExchange}
          onCancle={onCancle}
          contentDisable={contentDisable && image !== null && image !== "" && !(item && item[index]?.isNewAdded == true)}
          isProduct={isProduct}
          editable={editable || image === null || image === "" || (item && item[index]?.isNewAdded == true)}
        />
      ))}
    </div>
  );
};

export default DraggableContainer;
